import { AnyAction } from 'redux'
import { IEvent } from '../../models/Event'
import { AuthorizationActions } from '../userAccount/actionNames'
import initialStore from './initialState'
import { ReservationsListActions } from './actionNames'

export default function(
  store: Readonly<IReservationsList> = initialStore,
  action: AnyAction,
) {
  switch (action.type) {
    case ReservationsListActions.SetDate:
      return {
        ...store,
        date: action.date,
      }

    case ReservationsListActions.SetSearch:
      return {
        ...store,
        search: action.search,
      }

    case ReservationsListActions.SetSorOrder:
      return {
        ...store,
        sortOrder: action.sortOrder,
      }
    case ReservationsListActions.SetReservations:
      return {
        ...store,
        canceledReservations: action.canceledReservations,
        loading: false,
        newReservations: action.newReservations,
        deletedReservations: action.deletedReservations,
      }

    case ReservationsListActions.LoadList:
      return {
        ...store,
        loading: true,
      }

    case AuthorizationActions.SignOffTheAccount:
    case AuthorizationActions.FlushState:
      return {
        ...initialStore,
      }
  }

  return store
}

export interface IReservationsList {
  date: Date
  sortOrder: ReservationSortOrder
  canceledReservations: IEvent[]
  newReservations: IEvent[]
  deletedReservations: IEvent[]
  loading: boolean
  search: string
}

export enum ReservationSortOrder {
  AddDate,
  StartDate,
}
